/* ==========================================================================
   vn-product.js — PDP behaviour (loaded by sections/main-product.liquid)
   Variant-driven UI (SKU, discount, stock, sticky price, gallery sync),
   colour-based variant-media filtering, option-value availability,
   mobile gallery dots + counter, lightbox (zoom + swipe),
   size chart modal, sticky ATC visibility, recommendations loader.
   Complements assets/theme.js, which owns variant resolution + price + ATC.
   ========================================================================== */
(function () {
  'use strict';

  var scope = document.querySelector('[data-vn-product]');
  if (!scope) return;

  var gallery = scope.querySelector('[data-pdp-gallery]');
  var stage = scope.querySelector('[data-vn-stage]');
  var slides = gallery
    ? Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-media]'))
    : [];
  var thumbs = gallery
    ? Array.prototype.slice.call(gallery.querySelectorAll('[data-vn-thumb]'))
    : [];

  var variants = [];
  var variantsEl = scope.querySelector('[data-vn-variants]');
  if (variantsEl) {
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (error) {
      variants = [];
    }
  }

  var variantMedia = { color_option_position: 0, colors: [] };
  var variantMediaEl = scope.querySelector('[data-vn-variant-media]');
  if (variantMediaEl) {
    try {
      variantMedia = JSON.parse(variantMediaEl.textContent);
    } catch (error) {
      variantMedia = { color_option_position: 0, colors: [] };
    }
  }

  var colorOptionPosition = parseInt(variantMedia.color_option_position, 10) || 0;

  function selectedOptions() {
    var selected = [];
    scope.querySelectorAll('[data-vn-option-input]:checked').forEach(function (el) {
      selected[parseInt(el.getAttribute('data-position'), 10) - 1] = el.value;
    });
    return selected;
  }

  function matches(variant, options, requireAvailable) {
    for (var j = 0; j < variant.options.length; j++) {
      if (options[j] !== undefined && variant.options[j] !== options[j]) return false;
    }
    return requireAvailable ? variant.available : true;
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], options, false)) return variants[i];
    }
    return null;
  }

  function findVariantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function getSelectedColor() {
    if (!colorOptionPosition) return null;
    var inputs = scope.querySelectorAll('[data-vn-option-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].checked) continue;
      if (parseInt(inputs[i].getAttribute('data-position'), 10) === colorOptionPosition) {
        return inputs[i].value;
      }
    }
    return null;
  }

  /* ---------------- Colour-based media filtering ---------------- */
  /* data-vn-variant-media carries { color_option_position, any_alt_mapping,
     colors: [{ value, media_ids }] } — media grouped per colour by alt text +
     variant featured images, built in sections/main-product.liquid. When the
     product has no alt-based mapping at all, the map stays empty and the
     gallery shows every image (legacy behaviour). */
  function buildColorMediaMap() {
    var map = {};
    if (!colorOptionPosition || !variantMedia.any_alt_mapping) return map;
    if (!variantMedia.colors || !variantMedia.colors.length) return map;

    variantMedia.colors.forEach(function (entry) {
      if (!entry || !entry.value) return;
      map[entry.value] = entry.media_ids || [];
    });

    return map;
  }

  var colorMediaMap = buildColorMediaMap();

  function visibleSlides() {
    return slides.filter(function (slide) {
      return !slide.classList.contains('is-hidden');
    });
  }

  function visibleThumbs() {
    return thumbs.filter(function (thumb) {
      return !thumb.classList.contains('is-hidden');
    });
  }

  function updateGalleryUI(mediaId) {
    if (!mediaId) return;
    var strId = String(mediaId);
    var visible = visibleSlides();
    var visibleIndex = -1;

    for (var i = 0; i < visible.length; i++) {
      if (visible[i].getAttribute('data-media-id') === strId) {
        visibleIndex = i;
        break;
      }
    }

    slides.forEach(function (slide) {
      slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === strId);
    });
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === strId);
    });

    var dotsWrap = scope.querySelector('[data-pdp-dots]');
    if (dotsWrap) {
      var dotsList = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-pdp-dot]'));
      dotsList.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-media-id') === strId);
      });
    }

    var galleryCounter = scope.querySelector('[data-pdp-gallery-counter]');
    if (galleryCounter && visible.length > 0) {
      var current = visibleIndex >= 0 ? visibleIndex + 1 : 1;
      galleryCounter.textContent = current + ' / ' + visible.length;
    }
  }

  function setActiveMedia(mediaId) {
    if (!gallery) return;
    updateGalleryUI(mediaId);
  }

  function scrollToMedia(index) {
    if (!stage) return;
    var visible = visibleSlides();
    var el = visible[index] || visible[0];
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    var id = el.getAttribute('data-media-id');
    if (id) updateGalleryUI(id);
  }

  function syncGalleryCounter() {
    var visible = visibleSlides();
    var counter = scope.querySelector('[data-pdp-gallery-counter]');
    if (!counter) return;
    var active = visible.find(function (slide) {
      return slide.classList.contains('is-active');
    });
    var idx = active ? visible.indexOf(active) : 0;
    counter.textContent = (visible.length ? idx + 1 : 0) + ' / ' + visible.length;
  }

  function filterGalleryByColor(colorValue) {
    if (!gallery || !colorOptionPosition) return;
    var mediaIds = colorValue && colorMediaMap[colorValue] ? colorMediaMap[colorValue] : [];
    var filterActive = colorValue && mediaIds.length > 0 && mediaIds.length < slides.length;

    slides.forEach(function (slide) {
      var id = parseInt(slide.getAttribute('data-media-id'), 10);
      var hidden = filterActive && mediaIds.indexOf(id) === -1;
      slide.classList.toggle('is-hidden', hidden);
      if (hidden) slide.classList.remove('is-active');
    });

    thumbs.forEach(function (thumb) {
      var id = parseInt(thumb.getAttribute('data-media-id'), 10);
      var hidden = filterActive && mediaIds.indexOf(id) === -1;
      thumb.classList.toggle('is-hidden', hidden);
      thumb.hidden = hidden;
      if (hidden) thumb.classList.remove('is-active');
    });

    var dotsWrap = scope.querySelector('[data-pdp-dots]');
    if (dotsWrap) {
      Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-pdp-dot]')).forEach(function (dot, index) {
        var slide = slides[index];
        var hidden = slide ? slide.classList.contains('is-hidden') : true;
        dot.classList.toggle('is-hidden', hidden);
      });
    }

    var visible = visibleSlides();
    var active = visible.find(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (!active && visible.length) {
      var firstId = visible[0].getAttribute('data-media-id');
      setActiveMedia(firstId);
    }

    syncGalleryCounter();
  }

  /* ---------------- Option-value availability ---------------- */
  function refreshAvailability() {
    if (!variants.length) return;
    var selected = selectedOptions();
    scope.querySelectorAll('[data-vn-option-input]').forEach(function (input) {
      var pos = parseInt(input.getAttribute('data-position'), 10) - 1;
      var test = selected.slice();
      test[pos] = input.value;
      var exists = false;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], test, true)) {
          exists = true;
          break;
        }
      }
      var label = scope.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-unavailable', !exists);
    });
  }

  /* ---------------- Variant-driven UI ---------------- */
  function refreshVariantInfo() {
    var variant = findVariant(selectedOptions());
    if (!variant) return;

    var skuRow = scope.querySelector('[data-pdp-sku-row]');
    scope.querySelectorAll('[data-pdp-sku]').forEach(function (el) {
      el.textContent = variant.sku || '';
    });
    if (skuRow) skuRow.hidden = !variant.sku;

    var discount = scope.querySelector('[data-pdp-discount]');
    if (discount) {
      if (variant.discount_percent) {
        discount.textContent = variant.discount_percent + '% Off';
        discount.hidden = false;
      } else {
        discount.textContent = '';
        discount.hidden = true;
      }
    }

    var stock = scope.querySelector('[data-pdp-stock]');
    if (stock) {
      var isTracked = variant.inventory_management === 'shopify';
      var qty = variant.inventory_qty;
      var showStockNotice = isTracked && qty !== null && qty > 0;
      stock.hidden = !showStockNotice;
      var countEl = stock.querySelector('[data-pdp-stock-count]');
      if (countEl && showStockNotice) countEl.textContent = qty;
    }

    var stickyPrice = scope.querySelector('[data-pdp-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = variant.price;
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('[data-vn-option-input]') : null;
    if (!input || !scope.contains(input)) return;

    var position = parseInt(input.getAttribute('data-position'), 10);
    if (position === colorOptionPosition) {
      filterGalleryByColor(input.value);
    }

    refreshVariantInfo();
    refreshAvailability();
  });
  refreshAvailability();

  /* ---------------- Colour overflow pagination ----------------
     More than 5 colour options → first 5 cards + a "+N more" chip that
     expands the rest. Fully data-driven from the rendered swatches; the
     currently selected colour is never hidden. */
  (function initColorOverflow() {
    var VISIBLE = 5;
    scope.querySelectorAll('.vn-option--color .vn-option__values').forEach(function (wrap) {
      var labels = Array.prototype.slice.call(wrap.querySelectorAll('.vn-option__label--swatch-card'));
      if (labels.length <= VISIBLE) return;

      var visible = labels.slice(0, VISIBLE);
      var checkedInput = wrap.querySelector('[data-vn-option-input]:checked');
      var checkedLabel = checkedInput ? wrap.querySelector('label[for="' + checkedInput.id + '"]') : null;
      if (checkedLabel && visible.indexOf(checkedLabel) === -1) {
        visible[VISIBLE - 1] = checkedLabel;
      }

      labels.forEach(function (label) {
        if (visible.indexOf(label) === -1) label.classList.add('is-extra-hidden');
      });

      var extra = labels.length - VISIBLE;
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'vn-option__label--more';
      more.setAttribute('aria-expanded', 'false');
      more.textContent = '+' + extra + ' more';
      more.addEventListener('click', function () {
        labels.forEach(function (label) {
          label.classList.remove('is-extra-hidden');
        });
        more.remove();
      });
      wrap.appendChild(more);
    });
  })();

  /* ---------------- Initial gallery filter from URL or selected colour ---------------- */
  function initGalleryFilter() {
    if (!colorOptionPosition) return;
    var urlVariantId = null;
    if (window.location.search) {
      var match = window.location.search.match(/[?&]variant=(\d+)/);
      if (match) urlVariantId = parseInt(match[1], 10);
    }

    var initialColor = null;
    if (urlVariantId) {
      var variant = findVariantById(urlVariantId);
      if (variant && variant.options[colorOptionPosition - 1]) {
        initialColor = variant.options[colorOptionPosition - 1];
      }
    }

    if (!initialColor) {
      initialColor = getSelectedColor();
    }

    if (initialColor) {
      filterGalleryByColor(initialColor);
    }
  }
  initGalleryFilter();

  /* ---------------- Mobile gallery dots + counter ---------------- */
  var dotsWrap = scope.querySelector('[data-pdp-dots]');
  var galleryCounter = scope.querySelector('[data-pdp-gallery-counter]');

  if (stage && (dotsWrap || galleryCounter)) {
    var dots = dotsWrap
      ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-pdp-dot]'))
      : [];

    function getActiveSlideByPosition() {
      var visible = visibleSlides();
      if (!visible.length || !stage) return null;

      var stageRect = stage.getBoundingClientRect();
      var stageCenter = stageRect.left + stageRect.width / 2;

      var closestSlide = null;
      var closestDist = Infinity;

      for (var i = 0; i < visible.length; i++) {
        var slide = visible[i];
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenter - stageCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestSlide = slide;
        }
      }
      return closestSlide;
    }

    function syncActiveFromScroll() {
      var active = getActiveSlideByPosition();
      if (active) {
        var id = active.getAttribute('data-media-id');
        if (id) updateGalleryUI(id);
      }
    }

    // A. IntersectionObserver for smooth viewport entry detection
    if ('IntersectionObserver' in window) {
      var stageObserver = new IntersectionObserver(
        function (entries) {
          var bestEntry = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
                bestEntry = entry;
              }
            }
          });
          if (bestEntry && bestEntry.intersectionRatio >= 0.5) {
            var id = bestEntry.target.getAttribute('data-media-id');
            if (id) updateGalleryUI(id);
          }
        },
        {
          root: stage,
          threshold: [0.5, 0.7, 0.9]
        }
      );

      slides.forEach(function (slide) {
        stageObserver.observe(slide);
      });
    }

    // B. Scroll event listener with requestAnimationFrame
    var scrollTicking = false;
    stage.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          scrollTicking = false;
          syncActiveFromScroll();
        });
      },
      { passive: true }
    );

    // C. scrollend & touchend fallback
    if ('onscrollend' in window) {
      stage.addEventListener('scrollend', syncActiveFromScroll, { passive: true });
    }
    stage.addEventListener('touchend', function () {
      setTimeout(syncActiveFromScroll, 80);
      setTimeout(syncActiveFromScroll, 250);
    }, { passive: true });

    // D. Click on dots
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var id = dot.getAttribute('data-media-id');
        updateGalleryUI(id);
        var visible = visibleSlides();
        var index = visible.findIndex(function (slide) {
          return slide.getAttribute('data-media-id') === id;
        });
        if (index >= 0) {
          scrollToMedia(index);
        }
      });
    });
  }

  /* ---------------- Lightbox ---------------- */
  var lightbox = scope.querySelector('[data-pdp-lightbox]');
  if (lightbox && slides.length) {
    var lbStage = lightbox.querySelector('[data-pdp-lightbox-stage]');
    var lbCounter = lightbox.querySelector('[data-pdp-lightbox-counter]');
    var current = 0;
    var lastFocus = null;

    function lightboxSlides() {
      return visibleSlides();
    }

    function lbIndexForSlide(slide) {
      var id = slide.getAttribute('data-media-id');
      var list = lightboxSlides();
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-media-id') === id) return i;
      }
      return -1;
    }

    function render(index) {
      var list = lightboxSlides();
      if (!list.length) return;
      current = (index + list.length) % list.length;
      lbStage.classList.remove('is-zoomed');
      lbStage.innerHTML = '';
      var source = list[current];
      var type = source.getAttribute('data-media-type');
      var node = null;
      if (type === 'video' || type === 'external_video' || type === 'model') {
        var media = source.querySelector('video, iframe, model-viewer');
        if (media) {
          node = media.cloneNode(true);
          if (node.tagName === 'VIDEO') {
            node.controls = true;
            node.autoplay = true;
          }
        }
      } else {
        var img = source.querySelector('img');
        node = document.createElement('img');
        if (img) {
          node.src = img.currentSrc || img.src;
          node.alt = img.alt || '';
        }
      }
      if (node) lbStage.appendChild(node);
      if (lbCounter) lbCounter.textContent = current + 1 + ' / ' + list.length;
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') render(current - 1);
      if (event.key === 'ArrowRight') render(current + 1);
    }

    function open(index) {
      lastFocus = document.activeElement;
      render(index);
      lightbox.hidden = false;
      document.body.classList.add('vn-no-scroll');
      document.addEventListener('keydown', onKey);
      var closeButton = lightbox.querySelector('.vn-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.classList.remove('vn-no-scroll');
      lbStage.innerHTML = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    slides.forEach(function (slide) {
      if (slide.getAttribute('data-media-type') !== 'image') return;
      var img = slide.querySelector('img');
      if (!img) return;
      img.addEventListener('click', function () {
        var index = lbIndexForSlide(slide);
        if (index >= 0) open(index);
      });
    });

    lightbox.querySelectorAll('[data-pdp-lightbox-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    var prevButton = lightbox.querySelector('[data-pdp-lightbox-prev]');
    var nextButton = lightbox.querySelector('[data-pdp-lightbox-next]');
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        render(current - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        render(current + 1);
      });
    }

    lbStage.addEventListener('click', function () {
      if (lbStage.querySelector('video, iframe, model-viewer')) return;
      lbStage.classList.toggle('is-zoomed');
    });
    lbStage.addEventListener('mousemove', function (event) {
      if (!lbStage.classList.contains('is-zoomed')) return;
      var img = lbStage.querySelector('img');
      if (!img) return;
      var rect = lbStage.getBoundingClientRect();
      img.style.transformOrigin =
        (((event.clientX - rect.left) / rect.width) * 100).toFixed(2) +
        '% ' +
        (((event.clientY - rect.top) / rect.height) * 100).toFixed(2) +
        '%';
    });

    var touchX = null;
    lbStage.addEventListener(
      'touchstart',
      function (event) {
        touchX = event.touches[0].clientX;
      },
      { passive: true }
    );
    lbStage.addEventListener(
      'touchend',
      function (event) {
        if (touchX === null) return;
        var delta = event.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 40) render(delta > 0 ? current - 1 : current + 1);
        touchX = null;
      },
      { passive: true }
    );
  }

  /* ---------------- Size chart modal ---------------- */
  var modal = scope.querySelector('[data-pdp-sizechart]');
  if (modal) {
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('vn-no-scroll');
      document.removeEventListener('keydown', onModalKey);
    }
    function onModalKey(event) {
      if (event.key === 'Escape') closeModal();
    }
    scope.querySelectorAll('[data-pdp-sizechart-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        modal.hidden = false;
        document.body.classList.add('vn-no-scroll');
        document.addEventListener('keydown', onModalKey);
      });
    });
    modal.querySelectorAll('[data-pdp-sizechart-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
  }

  /* ---------------- Sticky add-to-cart visibility ---------------- */
  var sticky = scope.querySelector('[data-pdp-sticky]');
  var form = scope.querySelector('form[data-vn-atc]');
  if (sticky && form && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(form);
  }

  /* ---------------- Delivery (PIN) checker ---------------- */
  var pinInput = scope.querySelector('[data-pdp-pin]');
  var pinButton = scope.querySelector('[data-pdp-pin-check]');
  var pinResult = scope.querySelector('[data-pdp-pin-result]');
  if (pinInput && pinButton && pinResult) {
    var checkPin = function () {
      var pin = pinInput.value.trim();
      if (/^\d{6}$/.test(pin)) {
        pinResult.textContent =
          'Delivery available to ' + pin + '. Estimated 3–7 business days. COD available on eligible orders.';
        pinResult.classList.remove('is-error');
      } else {
        pinResult.textContent = 'Please enter a valid 6-digit PIN code.';
        pinResult.classList.add('is-error');
      }
      pinResult.hidden = false;
    };
    pinButton.addEventListener('click', checkPin);
    pinInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkPin();
      }
    });
  }

  /* ---------------- You May Also Like (recommendations API) ---------------- */
  document.querySelectorAll('[data-pdp-recommendations]').forEach(function (host) {
    var url = host.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-pdp-recs-root]');
        var root = host.closest('.shopify-section') || host.parentNode;
        if (content && content.textContent.trim() !== '') {
          root.innerHTML = content.innerHTML;
        } else if (root) {
          root.hidden = true;
        }
      })
      .catch(function () {
        var root = host.closest('.shopify-section');
        if (root) root.hidden = true;
      });
  });

  /* ---------------- Available Offers (Coupon Copy Handler) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-coupon-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-coupon-copy');
    if (!code) return;

    function showCopied() {
      btn.classList.add('is-copied');
      var tooltip = btn.querySelector('.vn-coupon-card__tooltip');
      if (tooltip) tooltip.textContent = 'Copied!';
      try {
        fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' });
      } catch (err) {}
      setTimeout(function () {
        btn.classList.remove('is-copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(showCopied).catch(function () {
        fallbackCopy(code, showCopied);
      });
    } else {
      fallbackCopy(code, showCopied);
    }
  });

  function fallbackCopy(text, callback) {
    var temp = document.createElement('input');
    temp.value = text;
    document.body.appendChild(temp);
    temp.select();
    try {
      document.execCommand('copy');
    } catch (err) {}
    document.body.removeChild(temp);
    if (callback) callback();
  }

  /* ---------------- Available Offers Drag / Swipe ---------------- */
  var offersSlider = scope.querySelector('[data-vn-offers-track]');
  if (offersSlider) {
    var isOfferDown = false;
    var offerStartX = 0;
    var offerScrollLeft = 0;

    offersSlider.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-coupon-copy]')) return;
      isOfferDown = true;
      offersSlider.classList.add('is-dragging');
      offerStartX = e.pageX - offersSlider.offsetLeft;
      offerScrollLeft = offersSlider.scrollLeft;
    });

    document.addEventListener('mouseup', function () {
      if (!isOfferDown) return;
      isOfferDown = false;
      if (offersSlider) offersSlider.classList.remove('is-dragging');
    });

    offersSlider.addEventListener('mousemove', function (e) {
      if (!isOfferDown) return;
      e.preventDefault();
      var x = e.pageX - offersSlider.offsetLeft;
      var walk = (x - offerStartX) * 1.5;
      offersSlider.scrollLeft = offerScrollLeft - walk;
    });
  }
})();
